export const buildQuery = (search, from, to) => {
  let query = ``
  if (search) query += `&search=${search}`
  if (from.isChecked) query += `&from=${from.value}`
  if (to.isChecked) query += `&to=${to.value}`
  return query
}
